import React, { ReactNode, createContext, useContext } from 'react'

import { useSurveyCategoricalVersion } from '../hooks/useSurveyCategoricalVersion'

interface AnalyticsFeatureFlagContextValue {
  useAnalyticsAPI: boolean | null // null = loading/unknown, true = use new API, false = use old API
  isLoading: boolean
}

const AnalyticsFeatureFlagContext = createContext<
  AnalyticsFeatureFlagContextValue | undefined
>(undefined)

interface AnalyticsFeatureFlagProviderProps {
  children: ReactNode
  surveyId: string
}

export const AnalyticsFeatureFlagProvider: React.FC<
  AnalyticsFeatureFlagProviderProps
> = ({ children, surveyId }) => {
  const { isLoading, useNewApi } = useSurveyCategoricalVersion(surveyId)

  return (
    <AnalyticsFeatureFlagContext.Provider
      value={{ useAnalyticsAPI: useNewApi, isLoading }}
    >
      {children}
    </AnalyticsFeatureFlagContext.Provider>
  )
}

export const useAnalyticsFeatureFlag = (): AnalyticsFeatureFlagContextValue => {
  const context = useContext(AnalyticsFeatureFlagContext)
  if (context === undefined) {
    throw new Error(
      'useAnalyticsFeatureFlag must be used within an AnalyticsFeatureFlagProvider'
    )
  }
  return context
}
